import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Downloads from "./components/Downloads";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Questions from "./components/Questions";

function App() {
  return (
   <>
    <Header />
    <Hero />
    <Features />
    <Downloads />
    <Questions />
    <Contact />
    <Footer />
   </>
  );
}

export default App;
